import {Component, OnInit, ViewChild} from '@angular/core';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmationService, Paginator} from 'primeng/primeng';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {Router} from '@angular/router';
import {UserService} from '../../../../../components/manageuser/user/user.service';
import {AddUserFirebaseService} from '../../../../../components/manageuser/adduser/adduserfirebase.service';
import {DepartmentService} from '../../../../../components/manageuser/department/department.service';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {asEnumerable} from 'linq-es2015';
import {SectionService} from '../../../../../components/manageuser/sections/sections.service';

@Component({
  selector: 'app-student-profile',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.css']
})

export class ManageUserComponent implements OnInit {
  public data: any;
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public dpagge: number = 1;
  public numPages: number = 0;
  public searchString: any;
  public spinnershow: boolean = false;
  public SelectedGrades = [];
  public departmentList: any;
  public departmentListId: any;
  public departmentListName: any;
  public StandardId: any;
  public StandardName: any;
  public isList: boolean = true;
  public mappedData: any;
  public standards: any;
  public schoolid: any;
  public userSectionId: any;
  public userSectionName: any;
  public userStandardsName: any;
  public rolesList: any = [];
  public SectionData: any = [];
  public cat: any = []
  public arry1: any;
  public arry2: any;
  public arry3: any;
  public arry4: any;
  public finalString: any;
  public gradeString: any;
  public sectionString: any = [];

  adminflag: boolean = false;
  public responseData = [];
  public selectedDepartment = [];
  public gradeFormat = '';
  public classFormat = '';
  public secFormat = '';
  constructor(private router: Router, private userService: UserService, private messageService: MessageService,
              private adduserfirebaseService: AddUserFirebaseService, private localStorage: LocalStorageService,
              private confirmationService: ConfirmationService, private SectionService: SectionService,
              private departmentService: DepartmentService, private noticeboardService: NoticeboardService,) {
  }
  ngOnInit() {
    this.arry1 = [];
    this.GetDepartment();
    this.getClassSection();
    this.getSections();
    // this.getUserList(this.bigCurrentPage);
  }


  onSearchChange(searchString) {
    this.searchString = searchString;
    this.getUserList(this.bigCurrentPage);
  }

  private getUserList(pagenum) {
    this.spinnershow = true;
    this.userService.getSchoolUserQuanta(pagenum, this.searchString).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        console.log('data',response)
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.responseData = response['items'];
        this.responseData.map(userDetail => {
          userDetail.selectionarray = [];
          userDetail.distinctArray = [];
          userDetail.department = [];
          userDetail.clases = [];
          userDetail.grade = [];
          this.selectedDepartment = [];
          this.gradeFormat = '';
          this.classFormat = '';
          this.secFormat = '';

          userDetail.selectedSbAccessPermission.forEach(selPer => {

            // junior middle and senior grade//
            this.SectionData.forEach(z => {
              if (selPer.sectionalGradeId == z.Id) {
                userDetail.selectionarray.push(z);
                userDetail.distinctArray = userDetail.selectionarray.filter((n, i) => userDetail.selectionarray.indexOf(n) === i);
              }
            });

            // category pushing into data//
            this.departmentList.forEach(department => {
              if (selPer.UserSpecializationCategoryId == department.Id) {
                this.selectedDepartment.push(department);
              }
            });
            userDetail.department = asEnumerable(this.selectedDepartment).GroupBy(
              x => x.Name, x => x, (key, b) => {
                return { Name: key, detail: asEnumerable(b).ToArray() }
              }).ToArray();

            this.mappedData.forEach(x => {
              if ((selPer.standardid == x.standardId) && (selPer.Rank == 3)) {
                userDetail.grade.push(x);
              }
            });
            this.mappedData.forEach(t => {
              if (selPer.standardid == t.standardId) {
                t.Sections.map(sec => {
                  sec.standardId = t.standardId
                  sec.standardsName = t.standardsName
                  sec.fullName = t.standardsName + ' ' + sec.sectionName;
                })
              }
            });
            this.mappedData.forEach(grade => {
              grade.Sections.forEach(grd => {
                if ((selPer.sectionid == grd.SectionId) && (selPer.standardid == grd.standardId)) {
                  userDetail.clases.push(grd);
                }
              });
            });
          });
          userDetail.grade.forEach((gradesfort, index) => {
            if (userDetail.grade.length - 1 !== index) {
              this.gradeFormat = this.gradeFormat + gradesfort.standardsName + ',' + ' ';
            } else {
              this.gradeFormat = this.gradeFormat + gradesfort.standardsName;

            }
          });
          userDetail.clases.forEach((classes, index) => {
            if (userDetail.clases.length - 1 !== index) {
              this.classFormat = this.classFormat + classes.fullName + ',' + ' ';
            } else {
              this.classFormat = this.classFormat + classes.fullName

            }

          });
          userDetail.distinctArray.forEach((section, iindex) => {
            if (userDetail.distinctArray.length - 1 !== iindex) {
              this.secFormat = this.secFormat + section.Name + ',' + ' ';
            } else {
              this.secFormat = this.secFormat + section.Name;
            }

          });
          console.log(userDetail);
          userDetail.selcClasses = this.classFormat;
          userDetail.selcSection = this.secFormat;
          userDetail.gradethis = this.gradeFormat;
          delete userDetail.clases
          delete userDetail.selectionarray
          delete userDetail.grade
          // console.log(userDetail,'userDetail');
        })
      },
      error => {
      });
    this.getSections();
    this.getClassSection();

  }

  confirm(User) {

    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        this.deleteUser(User);

      }
    });
  }
  private deleteUser(User) {
    this.userService.deleteUserEntry(User).finally(() => { }).subscribe(
      response => {
        this.messageService.add({ severity: 'warning', summary: 'Talkative Parents', detail: 'User Deleted Successfully' });
        // this.adduserfirebaseService.deleteUser(User);
        this.getUserList(this.bigCurrentPage);
      },
      error => {

      });

  }
  addUser() {
    this.router.navigate(['parent/add-manage-user']);
  }

  editUser(item) {
    var userId = item;
    this.router.navigate(['parent/add-manage-user', userId]);
  }
  changeSort(event) {

  }
  pageChanged(event) {
    this.getUserList(event.page);
  }

  //main mappedData for grades and section
  private getClassSection() {
    this.noticeboardService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        this.mappedData = response;
      },
      error => {
      });
  }
  //get department
  public GetDepartment() {
    var pagenum;
    var searchString;
    this.spinnershow = true;
    this.departmentService.GetCategory(pagenum, this.searchString, this.isList, 1000).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.departmentList = response['items'];
        this.getUserList(this.bigCurrentPage);
      }
    )
  }

  //get section for catagory sectaionahead
  public getSections() {
    this.SectionService.getSections(this.bigCurrentPage,this.searchString).finally(() => { }).subscribe(response => {
      this.SectionData = response['items'];
    })
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/manage-user/manage-user/manage-user.component.ts